import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  // Kullanıcı giriş yapmamışsa login sayfasına yönlendir
  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // Admin paneline erişim kontrolü
  if (user.role !== 'admin' && user.role !== 'editor') {
    return <Navigate to="/" replace />;
  }

  // Editörlerin erişemeyeceği sayfalar
  const restrictedPaths = ['/admin/users'];
  const isRestrictedPath = restrictedPaths.some(path => location.pathname.startsWith(path));

  // Eğer editör kısıtlı bir sayfaya erişmeye çalışıyorsa
  if (user.role === 'editor' && isRestrictedPath) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default AdminRoute; 